import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import * as moment from 'moment'
import { allMonths, Month } from '../../../../api/models/months.enum'
import { NavigationPaths } from '../../../common/components/hierarch-menu/hierarchy-menu.component'
import { TimekeeperService } from '../../../common/services/time-keeper.service'
import { Utils } from '../../../common/utils/utils'
import { IDateable } from './idateable.interface'
import { IDateSelectorConfig } from './idateselectorconfig.interface'
import { notUndefined } from '../../../common/utils/conditional-assert'

@Component({
    selector: 'ppw-app-date-selector',
    templateUrl: './date-selector.component.html',
    styleUrls: ['./date-selector.component.scss']
})
export class DateSelectorComponent implements OnInit {
    @Output() readonly emitCriteria: EventEmitter<IDateable> = new EventEmitter()
    @Input() config!: IDateSelectorConfig

    trackBy = Utils.trackByIndex
    criteria!: IDateable
    months!: Array<Month>
    years!: Array<number>
    selectedMonth?: string // a month can be undefined
    selectedYear!: number // Year should always be filled in.

    selectedMonthChanged(month: Month): void {
        if (month !== undefined) {
            const startDate = moment()
            const endDate = moment()
            if (this.selectedYear) {
                startDate.set({ year: this.selectedYear })
                endDate.set({ year: this.selectedYear })
            }
            const monthIndex = this.months.findIndex((m) => m === month)
            startDate.set({ month: monthIndex })
            startDate.startOf('month')
            endDate.set({ month: monthIndex })
            endDate.endOf('month')
            this.criteria.startDate = startDate
            this.criteria.endDate = endDate
            this.criteria.month = month
        } else {
            this.criteria.month = undefined
            this.selectedYearChanged(this.selectedYear) // Use the year range instead.
        }
    }

    selectedYearChanged(selectedYear: number): void {
        const startDate = moment()
        const endDate = moment()
        startDate.set({ year: selectedYear })
        endDate.set({ year: selectedYear })
        if (this.selectedMonth === undefined) {
            startDate.startOf('year')
            endDate.endOf('year')
        } else {
            const monthIndex = this.months.findIndex((m) => m === this.selectedMonth)
            startDate.set({ month: monthIndex })
            startDate.startOf('month')
            endDate.set({ month: monthIndex })
            endDate.endOf('month')
        }

        this.criteria.startDate = startDate
        this.criteria.endDate = endDate
        this.criteria.year = selectedYear
    }

    constructor(public timekeeperService: TimekeeperService) {}

    ngOnInit(): void {
        this.months = allMonths
        this.years = TimekeeperService.generateYears()

        if (this.config.page === NavigationPaths.timecards) {
            this.criteria = this.timekeeperService.getTimeCardTimeFrame()
        } else if (this.config.page === NavigationPaths.timesheets) {
            this.criteria = this.timekeeperService.getTimesheetTimeFrame()
            if (this.criteria.month === null) {
                this.criteria.month = undefined
            }
        }
        this.selectedMonth = this.criteria.month
        // We cannot pass undefined years, but in the frontend the year should always be filled in.
        this.selectedYear = notUndefined(this.criteria.year)
    }

    execute(): void {
        if (this.config.page === NavigationPaths.timecards) {
            this.timekeeperService.timeCardTimeFrame = this.criteria
            this.emitCriteria.emit(this.criteria)
        } else if (this.config.page === NavigationPaths.timesheets) {
            this.timekeeperService.timesheetTimeFrame = this.criteria
            if (this.criteria.month === null) {
                this.criteria.month = undefined
            }
            this.emitCriteria.emit(this.criteria)
        }
    }
}
